@if (loadStatus$ | async; as loadStatus) {
  <div class="mat-slide-toggle-wrapper" [class.with-border]="withBorder">
    @if (
      loadStatus === LoadingStatus.Success ||
      loadStatus === LoadingStatus.Failed ||
      (loadStatus === LoadingStatus.Loading && mode === mediaPlayerMode.OnDemand)
    ) {
      <div class="input-media-player">
        <div class="player-container">
          @if (loadStatus !== LoadingStatus.Loading) {
            <i
              class="media-player-icon"
              [nimbusIcon]="(isPlaying$ | async) ? icons.PAUSE : icons.RESUME"
              [class.disabled]="(disabled || (noMedia$ | async)) && !isFakeEnabled"
              (click)="play($event)"
            ></i>
          } @else {
            @if (!hideSpinner) {
              <nimbus-spinner class="input-media-player-spinner" [absolute]="false"></nimbus-spinner>
            }
          }
          <i
            class="media-player-icon"
            [nimbusIcon]="icons.STOP"
            [class.disabled]="disabled || (noMedia$ | async) || loadStatus === LoadingStatus.Loading"
            (click)="stop($event)"
          ></i>
          <span class="player-text">{{ (noMedia$ | async) ? '00:00' : (elapsed$ | async | durationFormat: 'mm:ss') }}</span>
          <nimbus-slider
            [class.scaled]="isNeedBrowserScale"
            [min]="0"
            [max]="durationSeconds$ | async"
            [step]="0.1"
            [value]="elapsedSeconds$ | async"
            [disabled]="!(durationSeconds$ | async)"
            (valueChange)="onSliding($event)"
          ></nimbus-slider>
          <span class="player-text">{{ (noMedia$ | async) ? '00:00' : (duration$ | async | durationFormat: 'mm:ss') }}</span>
        </div>
      </div>
    }
    @if (loadStatus === LoadingStatus.Loading && mode !== mediaPlayerMode.OnDemand && !hideSpinner) {
      <div class="player-text">
        <nimbus-spinner [absolute]="false"></nimbus-spinner>
        {{ TranslationKeys.GeneralMediaPlayerResourceLoading | translate }}
      </div>
    }
    @if (loadStatus === LoadingStatus.Failed) {
      <div class="player-text mat-error">
        <i [nimbusIcon]="icons.EXCLAMATION_TRIANGLE" class="error-triangle"></i>
        <div>{{ errorMessage | translate }}</div>
        @if (showReloadButton) {
          <button nimbusPrimaryIconButton (click)="doReload()">
            <i class="button-icon" [nimbusIcon]="icons.RESET"></i>
            <nimbus-tooltip [position]="'left'" [text]="TranslationKeys.GeneralRegenerateAudio | translate"></nimbus-tooltip>
          </button>
        }
      </div>
    }
  </div>
}
